import asyncComponent from '../utils/AsyncComponent';

export default {
  Home: {
    routerPath: '/home',
    asyComponent: asyncComponent(() => import('../views/Home')),
  },
  ShowList: {
    routerPath: '/show/list/:categoryId?',
    asyComponent: asyncComponent(() => import('../views/ShowList')),
  },
  ShowDetail: {
    routerPath: '/show/detail/:showId',
    asyComponent: asyncComponent(() => import('../views/ShowDetail')),
  },
  ShowOrder: {
    routerPath: '/show/order',
    asyComponent: asyncComponent(() => import('../views/ComfirmOrder')),
  },
  ShowPeopleInfo: {
    routerPath: '/show/people/info',
    asyComponent: asyncComponent(() => import('../views/Info')),
  },
  OrderList: {
    routerPath: '/order/list',
    asyComponent: asyncComponent(() => import('../views/OrderList')),
  },
  OrderDetail: {
    routerPath: '/order/detail/:orderNo',
    asyComponent: asyncComponent(() => import('../views/OrderDetail')),
  },
  PayResult: {
    routerPath: '/pay/result',
    asyComponent: asyncComponent(() => import('../views/PayResult')),
  },
  SelectCity: {
    routerPath: '/select/city',
    asyComponent: asyncComponent(() => import('../views/SelectCity')),
  },
  TicketCode: {
    routerPath: '/order/ticketCode',
    asyComponent: asyncComponent(() => import('../views/TicketCode')),
  },
  Logistics: {
    routerPath: '/logistics/:orderNo',
    asyComponent: asyncComponent(() => import('../views/Logistics')),
  },
  AddPeople: {
    routerPath: '/order/addPeople',
    asyComponent: asyncComponent(() => import('../views/GetTicket/AddPeople')),
  },
  ExpressAdress: {
    routerPath: '/order/expressAdress',
    asyComponent: asyncComponent(() => import('../views/GetTicket/ExpressAdress')),
  },
  AddAdress: {
    routerPath: '/order/addAdress',
    asyComponent: asyncComponent(() => import('../views/GetTicket/AddAdress')),
  },
  Map: {
    routerPath: '/ticket/Adress',
    asyComponent: asyncComponent(() => import('../components/Map')),
  },
};
